require('styles/main.scss');

import Application from 'components/Application';

window.onload = ()=> {
  new Application();
}



// WEBPACK FOOTER //
// ./src/index.js